module.exports = __webpack_public_path__ + "static/media/de_overpass.9a0e909e.svg";